/* unplugin-vue-components disabled */import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f4d087a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex flex-wrap"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["onClick"];
import { ref } from 'vue';

// Assuming the props are passed correctly, you might need to convert them to a reactive state if necessary

export default {
  __name: 'UploadedImagesGrid',
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  emits: ['handle-image', 'delete-image'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const _images = ref(props.images);
    const images = computed(() => {
      return _images.value.map(image => {
        return {
          ...image,
          thumbnail: image.versions?.find(({
            version
          }) => version === 'thumbnail')?.url || image.url
        };
      });
    });
    const deleteImage = image => {
      // Emit an event in case there's additional handling in the parent component
      emit('delete-image', image._id);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), image => {
        return _openBlock(), _createElementBlock("div", {
          key: image.id,
          class: "image-container"
        }, [_createElementVNode("div", {
          class: "w-[107px] h-[107px] m-1 border-[0.2px] border-white cursor-pointer justify-self-auto relative",
          onClick: $event => emit('handle-image', image)
        }, [_createElementVNode("img", {
          src: image.thumbnail,
          alt: "image",
          class: "w-full h-full object-contain"
        }, null, 8, _hoisted_3), _createElementVNode("div", {
          class: "delete-icon",
          onClick: _withModifiers($event => deleteImage(image), ["stop"])
        }, "🗑️", 8, _hoisted_4)], 8, _hoisted_2)]);
      }), 128))]);
    };
  }
};